const globalFunctions = {
    scrollToTop: function () {
        console.log('1');
        
        window.scrollTo({
            top: 0,
            // behavior: 'smooth' // 可选：平滑滚动
        });
    },
    scrollToId: function(id){
        window.location.href = id
    },
    toOpen: function(url){
        window.open(url, "_blank")
    }
};

export default globalFunctions;